import { useMutation } from 'react-query';
import { lovageApi } from 'src/axios';
import { VoicemailSettings } from './useVoicemailSettings';

// Pick the fields from VoicemailSettings
export type UpdateVoicemailSettingsRequest = Pick<
  VoicemailSettings,
  'alv_id' | 'send_notifications' | 'voicemail_email_addresses'
>;

const doRequest = (body: UpdateVoicemailSettingsRequest) =>
  lovageApi
    .patch<VoicemailSettings[]>(`/dashboard/voicemail/settings`, body)
    .then((res) => res.data);

export default function useUpdateVoicemailSettings() {
  const mutation = useMutation(doRequest);

  return {
    ...mutation,
  };
}
